(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bsm-app-download"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bsm-app-download')) {
    customElements.define('bsm-app-download', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.details = this.querySelector('details');
        this.trigger = this.querySelector('summary');
        this.panel = this.querySelector('.bsm-app-panel');
        if (!this.details || !this.trigger || !this.panel) return;
        if ('showPopover' in this.panel) this.panel.setAttribute('popover', 'manual');
        this.details.addEventListener('toggle', () => {
          if (this.details.open) {
            document.querySelectorAll('bsm-app-download').forEach(menu => { if (menu !== this) menu.close(); });
            if (this.panel.hasAttribute('popover')) this.panel.showPopover();
            this.positionPanel();
          } else if (this.panel.hasAttribute('popover') && this.panel.matches(':popover-open')) this.panel.hidePopover();
        }, options);
        document.addEventListener('click', event => { if (!this.contains(event.target)) this.close(); }, options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.details.open) { this.close(); this.trigger.focus(); }
        }, options);
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
        }, options);
        window.addEventListener('resize', () => this.close(), options);
        window.addEventListener('scroll', () => this.close(), { ...options, passive: true });
      }
      positionPanel() {
        if (!this.panel.hasAttribute('popover')) return;
        const anchor = this.trigger.getBoundingClientRect();
        const width = this.panel.getBoundingClientRect().width;
        const left = Math.max(12, Math.min(anchor.right - width, window.innerWidth - width - 12));
        const height = this.panel.getBoundingClientRect().height;
        const top = Math.max(12, Math.min(anchor.bottom + 12, window.innerHeight - height - 12));
        this.panel.style.left = `${left}px`;
        this.panel.style.top = `${top}px`;
      }
      close() { if (this.details) this.details.open = false; }
      disconnectedCallback() {
        if (this.panel?.hasAttribute('popover') && this.panel.matches(':popover-open')) this.panel.hidePopover();
        this.abortController?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bsm-personalization"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.BsmRecommendations) return;
  const KEY = 'bsm-storefront-recommendations-v1';
  const TTL = 30 * 86400000;
  const empty = () => ({ version: 1, searches: [], views: [] });
  const queryText = value => typeof value === 'string' ? value.trim().replace(/\s+/g, ' ').slice(0, 120) : '';
  const recent = value => value && Number.isFinite(value.at) && value.at > Date.now() - TTL && value.at <= Date.now() + 60000;
  const unique = (values, key) => values.filter((value, index, all) => all.findIndex(item => key(item) === key(value)) === index).slice(0, 20);
  let history = empty(), allowed = false, initialized = false, recordedPage = false;
  let generation = 0, controller, storageError = false;
  const sections = new Map();
  const read = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY));
      if (!saved || saved.version !== 1) return empty();
      return {
        version: 1,
        searches: unique((Array.isArray(saved.searches) ? saved.searches : []).filter(recent).map(s => ({ query: queryText(s.query), at: s.at })).filter(s => s.query).sort((a, b) => b.at - a.at), s => s.query.toLowerCase()),
        views: unique((Array.isArray(saved.views) ? saved.views : []).filter(recent).filter(v => /^\d+$/.test(String(v.id))).map(v => ({ id: String(v.id), at: v.at })).sort((a, b) => b.at - a.at), v => v.id)
      };
    } catch { return empty(); }
  };
  function save() {
    try {
      if (allowed) localStorage.setItem(KEY, JSON.stringify(history));
      else localStorage.removeItem(KEY);
      storageError = false;
    } catch { storageError = true; }
    updateSettings();
  }
  function rememberSearch(value) {
    if (!allowed) return;
    const query = queryText(value);
    if (!query || history.searches.some(s => s.query.toLowerCase() === query.toLowerCase() && Date.now() - s.at < 15000)) return;
    history.searches = [{ query, at: Date.now() }, ...history.searches.filter(s => s.query.toLowerCase() !== query.toLowerCase())].slice(0, 20);
    save();
  }
  function recordPage() {
    if (!allowed || recordedPage) return;
    recordedPage = true;
    const config = document.getElementById('bsm-recommendations-config');
    if (!config) return;
    if (config.dataset.searchPerformed === 'true') rememberSearch(config.dataset.search);
    const id = config.dataset.productId;
    if (/^\d+$/.test(id || '')) {
      history.views = [{ id, at: Date.now() }, ...history.views.filter(v => v.id !== id)].slice(0, 20);
      save();
    }
  }
  function invalidate() {
    generation++;
    controller?.abort();
    controller = undefined;
  }
  function resetGrids() {
    sections.forEach((state, section) => {
      if (!section.isConnected) { sections.delete(section); return; }
      state.grid.replaceChildren(...state.fallback.map(node => node.cloneNode(true)));
      const subtitle = section.querySelector('[data-bsm-rec-subtitle]');
      subtitle.textContent = subtitle.dataset.defaultText;
      section.dataset.personalized = 'false';
    });
  }
  function updateSettings() {
    const status = document.querySelector('[data-bsm-rec-status]');
    if (status) status.textContent = allowed ? status.dataset.onText : status.dataset.pausedText;
    const error = document.querySelector('[data-bsm-rec-error]');
    if (error) error.hidden = !storageError;
  }
  function openSettings() {
    const dialog = document.getElementById('bsm-recommendations-dialog');
    updateSettings();
    if (dialog && !dialog.open) dialog.showModal();
  }
  function endpoints() {
    const root = window.Shopify?.routes?.root || '/';
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    const sources = [
      ...history.searches.slice(0, 2).map(s => ({ kind: 'search', query: s.query, at: s.at })),
      ...history.views.slice(0, 2).map(v => ({ kind: 'view', id: v.id, at: v.at }))
    ].sort((a, b) => b.at - a.at);
    return sources.map((source, index) => {
      const url = new URL(root + (source.kind === 'search' ? 'search' : 'recommendations/products'), location.origin);
      url.searchParams.set('section_id', 'bsm-recommendations-source');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      if (source.kind === 'search') {
        url.searchParams.set('q', source.query);
        url.searchParams.set('type', 'product');
      } else {
        url.searchParams.set('product_id', source.id);
        url.searchParams.set('limit', '10');
        url.searchParams.set('intent', 'related');
      }
      return { url, weight: (source.kind === 'search' ? 100 : 80) / (index + 1) };
    });
  }
  async function renderRecommendations() {
    invalidate();
    resetGrids();
    if (!initialized || !allowed || ![...sections.values()].some(s => s.active)) return;
    const requests = endpoints();
    if (!requests.length) return;
    const version = generation;
    const requestController = new AbortController();
    controller = requestController;
    const timeout = setTimeout(() => requestController.abort(), 10000);
    const results = await Promise.allSettled(requests.map(async source => {
      const response = await fetch(source.url, { signal: requestController.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Recommendations unavailable');
      const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
      return { weight: source.weight, cards: [...documentResult.querySelectorAll('[data-bsm-results] > [data-bsm-product-id]')] };
    }));
    clearTimeout(timeout);
    if (version !== generation || !allowed) return;
    const ranked = new Map();
    for (const result of results) {
      if (result.status !== 'fulfilled') continue;
      result.value.cards.forEach((card, index) => {
        const id = card.dataset.bsmProductId;
        const score = result.value.weight - index * .2;
        const previous = ranked.get(id);
        if (!previous || score > previous.score) ranked.set(id, { card, score });
      });
    }
    const cards = [...ranked.values()].sort((a, b) => b.score - a.score).map(value => value.card);
    if (!cards.length) return;
    sections.forEach((state, section) => {
      if (!section.isConnected || !state.active) return;
      const limit = Number(section.dataset.limit) || 18;
      const selection = cards.slice(0, limit);
      const ids = new Set(selection.map(card => card.dataset.bsmProductId));
      selection.push(...state.fallback.filter(card => !ids.has(card.dataset.bsmProductId)).slice(0, Math.max(0, limit - selection.length)));
      state.grid.replaceChildren(...selection.map(card => card.cloneNode(true)));
      const subtitle = section.querySelector('[data-bsm-rec-subtitle]');
      subtitle.textContent = subtitle.dataset.personalizedText;
      section.dataset.personalized = 'true';
    });
  }
  function registerSections() {
    document.querySelectorAll('[data-bsm-recommendations]').forEach(section => {
      if (sections.has(section)) return;
      const grid = section.querySelector('[data-bsm-rec-grid]');
      const state = { grid, fallback: [...grid.children].map(node => node.cloneNode(true)), active: false };
      sections.set(section, state);
      if (!('IntersectionObserver' in window)) { state.active = true; renderRecommendations(); return; }
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect(); state.active = true; renderRecommendations();
      }, { rootMargin: '300px' });
      observer.observe(section);
    });
  }
  function refreshPrivacy() {
    try { allowed = window.Shopify?.customerPrivacy?.preferencesProcessingAllowed() === true; } catch { allowed = false; }
    initialized = true;
    history = allowed ? read() : empty();
    save();
    recordPage();
    updateSettings();
    renderRecommendations();
  }
  function start() {
    const dialog = document.getElementById('bsm-recommendations-dialog');
    document.addEventListener('click', event => {
      if (event.target.closest('[data-bsm-rec-open]')) { event.preventDefault(); openSettings(); }
      if (event.target.closest('[data-bsm-rec-close]')) dialog?.close();
    });
    dialog?.addEventListener('close', () => {
      if (location.hash === '#bsm-recommendations') window.history.replaceState(window.history.state, '', location.pathname + location.search);
    });
    dialog?.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = new URL(form.action || location.href, location.href);
      if (action.origin === location.origin && /\/search\/?$/.test(action.pathname)) rememberSearch(form.querySelector('[name="q"]')?.value);
    }, true);
    const checkHash = () => { if (location.hash === '#bsm-recommendations') openSettings(); };
    window.addEventListener('hashchange', checkHash); checkHash();
    document.addEventListener('visitorConsentCollected', refreshPrivacy);
    document.addEventListener('shopify:section:load', registerSections);
    window.addEventListener('pageshow', event => { if (event.persisted) refreshPrivacy(); });
    window.addEventListener('storage', event => {
      if (event.key === KEY || event.key === null) {
        history = allowed ? read() : empty();
        updateSettings(); renderRecommendations();
      }
    });
    registerSections();
    let attempts = 0;
    const loadPrivacy = () => {
      if (window.Shopify?.customerPrivacy) { refreshPrivacy(); return; }
      if (window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], refreshPrivacy);
      } else if (++attempts < 30) setTimeout(loadPrivacy, 200);
      else refreshPrivacy();
    };
    loadPrivacy();
  }
  window.BsmRecommendations = { openSettings };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
